exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".primary_button {\n  background-color: #003F73;\n  font-family: PoppinsMedium;\n  font-size: 1rem;\n}\n", ""]);

